const AmityFeeHeader = [
    { id: 1, label: "Total hostel fee for the entire duration of the PG degree course (Rs)", var: "coursefee" },
    { id: 2, label: "Average monthly expenditure on food and lodging for students (not staying at university hostel) (Rs", var: "hostelfee" },
];

export default AmityFeeHeader;
